import Spline from '@splinetool/react-spline';

export default function Scene() {
  return (
    <Spline scene="https://prod.spline.design/5H1bXfnW8F7cNyQX/scene.splinecode" />
  );
}
